import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 10001 ,北縣, 3
 */
export interface SiteRow {
    enum_id: string;
    enum_nm: string;
    enum_desc: string;
}

/**
 * @todo Api 回傳值
 */
export interface IdDocUploadViewDataResp extends GeneralResp {
    imageMaxSize: number;
    idFront: string;
    idBack: string;
    secondIdFront: string;
    handHeldIDCard: string;
    ssn: string;

    idCheck_P_Collection: Array<SiteRow>;
    idCheck_P: string;
    idCheck_T: string;
    idCheck_Y: string;
    idCheck_M: string;
    idCheck_D: string;
}

/**
 * @todo 身分證件上傳 ViewData
 */
const IdDocUploadViewData = (): Promise<IdDocUploadViewDataResp> => {
    const url = RouteUrlList.API_IdDocUploadViewData.path;
    const config = {
        params: { showOverlay: ApiClient.paramTypeEnum.true, getServiceAlert: ApiClient.paramTypeEnum.true }
    };
    return ApiClient.post(url, {}, config).then((res: AxiosResponse<IdDocUploadViewDataResp>) => {
        return res.data;
    });
};

export default IdDocUploadViewData;
